var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "twitter",
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.053,
    height: 33.355,
    viewBox: "0 0 41.053 33.355",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M41.053,51.949A17.547,17.547,0,0,1,36.2,53.278a8.369,8.369,0,0,0,3.7-4.652,16.819,16.819,0,0,1-5.337,2.037,8.416,8.416,0,0,0-14.558,5.755,8.666,8.666,0,0,0,.195,1.919,23.822,23.822,0,0,1-17.347-8.8A8.418,8.418,0,0,0,5.445,60.783a8.311,8.311,0,0,1-3.8-1.037v.092a8.455,8.455,0,0,0,6.743,8.27,8.4,8.4,0,0,1-2.207.277,7.441,7.441,0,0,1-1.593-.144A8.5,8.5,0,0,0,12.449,74.1a16.911,16.911,0,0,1-10.435,3.59A15.762,15.762,0,0,1,0,77.578a23.694,23.694,0,0,0,12.911,3.777c15.487,0,23.954-12.829,23.954-23.949,0-.372-.013-.731-.031-1.088A16.79,16.79,0,0,0,41.053,51.949Z",
    transform: "translate(0 -48)",
    fill: "#20404a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.3f33b60837a1c11161530e97d0342417.svg";
export { ForwardRef as ReactComponent };